import { render, staticRenderFns } from "./AddNewsList.vue?vue&type=template&id=668de9ca"
import script from "./AddNewsList.vue?vue&type=script&lang=js"
export * from "./AddNewsList.vue?vue&type=script&lang=js"
import style0 from "./AddNewsList.vue?vue&type=style&index=0&id=668de9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports